import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { club, assets, seasonLabel } from "../../data/sep26Data";
import { EASE_OUT } from "./hooks";

const Line = ({ children, delay = 0, reduce }) => (
  <span className="mask">
    <motion.span
      className="block"
      initial={reduce ? false : { y: "105%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero26 = () => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const bgScale = useTransform(scrollYProgress, [0, 1], [1, 1.06]);
  const textY = useTransform(scrollYProgress, [0, 1], ["0%", "36%"]);
  const textOpacity = useTransform(scrollYProgress, [0, 0.75], [1, 0]);

  return (
    <section
      id="inicio"
      ref={ref}
      data-testid="s26-hero"
      className="relative isolate min-h-[100svh] overflow-hidden grain"
    >
      <motion.div className="absolute inset-0 -z-20" style={reduce ? undefined : { y: bgY, scale: bgScale }}>
        <video
          className="h-full w-full object-cover"
          style={{ objectPosition: "60% 50%" }}
          src={assets.heroBg}
          poster={assets.heroBgPoster}
          autoPlay={!reduce}
          muted
          loop
          playsInline
          preload="auto"
          aria-hidden="true"
          data-testid="s26-hero-video"
        />
      </motion.div>
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "linear-gradient(90deg, rgba(7,10,28,.9) 0%, rgba(7,10,28,.62) 42%, rgba(7,10,28,.08) 100%), linear-gradient(0deg, var(--ink) 0%, transparent 34%)",
        }}
      />

      <motion.div
        className="wrap relative flex min-h-[100svh] flex-col justify-end pb-[clamp(56px,9vh,110px)] pt-32"
        style={reduce ? undefined : { y: textY, opacity: textOpacity }}
      >
        <div className="grid items-end gap-10">
          <div>
            <motion.p
              className="label mb-6"
              style={{ color: "var(--gold)" }}
              initial={reduce ? false : { opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.1 }}
            >
              {club.category} · {club.modality} · {seasonLabel}
            </motion.p>

            <h1 className="display hero-title" data-testid="s26-hero-title">
              <Line reduce={reduce} delay={0.15}>Arsenal</Line>
              <Line reduce={reduce} delay={0.27}>
                <span style={{ color: "var(--gold)" }}>de</span> Allende
              </Line>
            </h1>

            <motion.p
              className="serif mt-7 max-w-[34ch] text-[clamp(22px,2.6vw,34px)] leading-snug"
              initial={reduce ? false : { opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: EASE_OUT, delay: 0.7 }}
            >
              {club.slogan}
            </motion.p>

            <motion.div
              className="mt-9 flex flex-wrap gap-4"
              initial={reduce ? false : { opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: EASE_OUT, delay: 0.85 }}
            >
              <a href="#partido" className="btn" data-testid="s26-cta-partido">Próximo partido</a>
              <a href="#plantilla" className="btn btn--ghost" data-testid="s26-cta-plantilla">Ver la plantilla</a>
            </motion.div>
          </div>

        </div>
      </motion.div>
    </section>
  );
};
